import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Сброс скролла наверх при смене роута. В SPA при навигации позиция скролла
// окна сохраняется — перейдя с конца длинной страницы (FAQ) на другую (Ссылки),
// попадаешь в её середину/конец. Встроенный <ScrollRestoration> react-router
// требует data-router, а у нас обычный <Routes>, поэтому делаем вручную.
//
// Скроллим по pathname (не search/hash): смена query-фильтра позицию не сбивает.
// useLayoutEffect — сброс до отрисовки нового экрана, без видимого «прыжка».
export function ScrollToTop() {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
